import * as type from './type';
import util from 'common/js/util';

export default{
    //获取采购单列表(买家)
    [type.GET_PURCHASE_ORDER_LIST](context,option){
        util.post({
            params:{
                functionId: "purchaseOrderListApp",
                body: JSON.stringify(option.params)
            },
            sc (data){
                if(option && option.sc){
                    option.sc && option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },
    //获取采购单详情(买家)
    [type.SET_PURCHASE_ORDER_DETAIL](context,option){
        util.post({
            params: {
                functionId: 'purchaseOrderDetail',
                body: JSON.stringify({
                    'id': option.params.id
                })
            },
            sc (data){
                if(option && option.sc){
                    option.sc && option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },
    //取消采购单
    [type.CANCEL_PURCHASE_ORDER](context,option){
        util.post({
            params: {
                functionId: 'purchaseOrderCancel',
                body: JSON.stringify({
                    'id': option.params.id
                })
            },
            sc (data){
                if(option && option.sc){
                    option.sc && option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },



    //获取采购单列表(卖家)
    [type.GET_SELLER_PURCHASE_ORDER_LIST](context,option){
        util.post({
            params:{
                functionId: "sellerPurchaseOrderList",
                body: JSON.stringify(option.params)
            },
            sc (data){
                if(option && option.sc){
                    option.sc && option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },

    //获取采购单详情(卖家)
    [type.GET_SELLER_PURCHASE_ORDER_DETAIL](context, option){
        util.post({
            params: {
                functionId: 'sellerPurchaseOrderDetail',
                body: JSON.stringify(option.params)
            },
            sc (data){
                if(option && option.sc){
                    option.sc && option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },

    //采购单审核(卖家)
    [type.AUDIT_SELLER_PIRCHASE_ORDER](context, option){
        util.post({
            params: {
                functionId: 'sellerPurchaseOrderAudit',
                body: JSON.stringify(option.params)
            },
            sc (data){
                if(option && option.sc){
                    option.sc && option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },

    //获取要审核的采购单(卖家)
    [type.GET_SELLER_CHECK_PIRCHASE_ORDER](context, option){
        util.post({
            params: {
                functionId: 'sellerModifyPrice',
                body: JSON.stringify(option.params)
            },
            sc (data){
                if(option && option.sc){
                    option.sc && option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },
}



// WEBPACK FOOTER //
// ./src/store/purchase-order/actions.js